import { ColDef } from 'ag-grid-community';
import { TranslateService } from '@ngx-translate/core';

/**
 * Filter half of a boolean column: a set filter with the two values the
 * backend understands (`'true'` / `'false'`, string keys like every set
 * filter model) shown as Yes / No. Spread it into the column definition
 * after the display fields (WAP-1658). Without an explicit `filter` a
 * boolean column fell through to the text filter once the custom filter
 * popups replaced ag-grid's default resolution (WAP-1646).
 */
export function booleanSetFilterDef(
  translateService: TranslateService,
  options: { blankEntries?: boolean } = {},
): Pick<ColDef, 'filter' | 'filterParams'> {
  return {
    filter: 'agSetColumnFilter',
    filterParams: {
      ...(options.blankEntries ? { blankEntries: true } : {}),
      values: ['true', 'false'],
      valueFormatter: (params: { value: unknown }) =>
        translateService.instant(
          params.value === 'true'
            ? 'forms.form-option.yes'
            : 'forms.form-option.no',
        ),
      defaultToNothingSelected: true,
    },
  };
}
